var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarningTriangle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 8.383a.7.7 0 0 1 .7.7v4a.7.7 0 1 1-1.4 0v-4a.7.7 0 0 1 .7-.7M12.907 16.417a.9.9 0 0 0-1.8 0v.007a.9.9 0 0 0 1.8 0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.842 4.625c.958-1.655 3.359-1.656 4.318 0l7.205 12.442c.962 1.66-.25 3.716-2.159 3.716H4.795c-1.908 0-3.12-2.056-2.16-3.716zm3.106.701a1.098 1.098 0 0 0-1.895 0L3.847 17.768c-.412.712.1 1.615.948 1.615h14.411c.848 0 1.36-.903.948-1.615z",
  clipRule: "evenodd"
})));
export default SvgWarningTriangle;